// src/components/dataone/FuelEfficiencyCard.tsx
import React from 'react';

interface FuelData {
  engineId: string;
  transmissionId: string;
  fuelType: string;
  city: string;
  highway: string;
  combined: string;
}

export default function FuelEfficiencyCard({ epaFuelEfficiency }: { epaFuelEfficiency: FuelData[] }) {
  if (!epaFuelEfficiency || epaFuelEfficiency.length === 0) return null;

  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold">EPA Fuel Efficiency</h2>
      {epaFuelEfficiency.map((entry, index) => (
        <div key={index} className="border p-4 rounded shadow-sm">
          <p><strong>Fuel Type:</strong> {entry.fuelType}</p>
          <p><strong>City MPG:</strong> {entry.city}</p>
          <p><strong>Highway MPG:</strong> {entry.highway}</p>
          <p><strong>Combined MPG:</strong> {entry.combined}</p>
        </div>
      ))}
    </div>
  );
}
